import React from "react";
import { useSelector } from "react-redux";
import { stackedBarPairedPalette } from "../colors";
import D3StackedBar from "./D3StackedBar";
import RccCard from "../RccCard";
import { usePipelineMixProductLineData } from "../hooks/usePipelineMixData";

function PipelineMixByProductLineCard({ title, redirectToDashboard }) {
  const user = useSelector((state) => state.app.user || {});
  const { chartData, derivedCategories, appliedFilters, isLoading } =
    usePipelineMixProductLineData();

  return (
    <RccCard
      title={title || "Qualified Pipeline Mix by Product Line"}
      isLoading={isLoading}
      redirectToDashboard={redirectToDashboard || "Open Pipeline Mix Analysis"}
      appliedFilters={appliedFilters}
      focusVariant={"future"}
    >
      <D3StackedBar
        data={chartData}
        categories={derivedCategories}
        colorPalette={stackedBarPairedPalette}
        currencySymbol={user?.Currency}
        options={{ showLabels: true, showLegend: true }}
      />
    </RccCard>
  );
}

export default PipelineMixByProductLineCard;
